










































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/family/edit/EditCarte.vue'
import { getDefaultAloFamily, AloFamily } from '@/models/alo/AloFamily'
import { formatFinValidite, isValide } from '@/filters/formatFinValidite'
import { StatusCarte } from '@/enum/StatusCarte'
import { AloNewCarte, getDefaultAloNewCarte } from '@/models/alo/AloNewCarte'
import { directPayloadQuery } from '@/utils/api'
import apiFamily from '@/api/family'
import { formatDate } from '@/filters/formatDate'

@Component({
  name: 'ReadCommandes',    
   props: {
    family:{      
      default:getDefaultAloFamily()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadCommandes extends Vue {
  private family!:AloFamily
  private loading!:boolean
  private showNew = false
  private saving = false

  private newCarte:AloNewCarte = getDefaultAloNewCarte()

  get cartes(){    
    return this.family.commandes.reduce( (cartes,commande) => {
      cartes.push(...commande.rows.filter(r => !r.crwRetour).map(r => {
        return {
          ...r, 
          cmdId: commande.id,                    
          finValidite: (r?.forfait?.isAbonnement)?formatDate(r?.forfait?.cftDatengagement,"DD/MM/YYYY") :formatFinValidite(commande.cmdDatvalidation,r.forfait?.cftValiditeM!,"DD/MM/YYYY"),
          status:isValide(commande.cmdDatvalidation,r.forfait?.cftValiditeM!)?(r.crwQty*r.forfait?.cftNbEntree!>r.forfait?.nbUsed! || r.forfait?.isAbonnement)?StatusCarte.valide:StatusCarte.complet:StatusCarte.perime,
          isAbonnement:r.forfait?.isAbonnement
        }
      }))
      return cartes
    },[] as Array<any>)
  }
 
  private headers = [        
    { text: 'Cmd', value: 'cmdId', width:60,sortable:false},           
    { text: 'Num', value: 'id', width:80,sortable:false},           
    { text: 'Status', value: 'status', width:150},       
    { text: 'Forfait', value: 'libelle'},       
    { text: 'Qty', value: 'crwQty', width:80},       
    { text: 'Fin de validité / engagemnent', value: 'finValidite', width:130  },        
    { text: 'Utilisation', value: 'forfait.nbUsed', width:110 },
    { text: '', value: 'action', width:50 }, 
  ]

  get configuration(){
    return this.$store.myGetters.configuration
  }

  created(){
    this.$store.myActions.ADM_FORFAIT_ENSURE()
  }

  get forfaitList(){
    return this.$store.myGetters.forfaitList
  }

  addCarte(){
    this.newCarte = {...getDefaultAloNewCarte(),id:this.forfaitList[0]?.id??0}
    this.showNew = true
  }

  saveNewCarte(){
    this.saving = true
    directPayloadQuery(apiFamily.addCarte,{famId:this.family.id,carte:this.newCarte}).then((result)=>{
      //requete de nouveau les données de la famille
      this.showNew = false
      this.$store.myActions.ADM_FAMILY_DETAIL_REQUEST(this.family.id)
    }).finally(()=>{
      this.saving = false    
    })
  }

  editCarte(carte:any) { (this.$refs.edit as Edit).edit(this.family,carte) }
}
